export default "__VITE_ASSET__CYlLcskk__"